import { CustomTooltip } from './CustomTooltip'

export const AnimatedLockIcon = ({
  locked,
  disabled,
  onClick,
  testId,
  tooltip,
}: {
  locked: boolean
  disabled: boolean
  onClick: () => void
  testId: string
  tooltip: string
}): JSX.Element => {
  return (
    <>
      <CustomTooltip title={tooltip}>
        <span
          data-testid={testId}
          className={`table-action-icon ${disabled && 'disabled'}`}
          onClick={() => !disabled && onClick()}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
          }}
        >
          <svg
            viewBox="0 0 640 640"
            fill="currentColor"
            style={{
              width: '1.2em',
              height: '1.2em',
              position: 'absolute',
              opacity: locked ? 1 : 0,
              transition: 'opacity 0.35s ease-in-out',
            }}
          >
            <path d="M320 64C373 64 416 107 416 160L416 224L224 224L224 160C224 107 267 64 320 64zM192 160L192 224C156.7 224 128 252.7 128 288L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 288C512 252.7 483.3 224 448 224L448 160C448 89.3 390.7 32 320 32C249.3 32 192 89.3 192 160zM192 256L448 256C465.7 256 480 270.3 480 288L480 512C480 529.7 465.7 544 448 544L192 544C174.3 544 160 529.7 160 512L160 288C160 270.3 174.3 256 192 256zM336 352C336 343.2 328.8 336 320 336C311.2 336 304 343.2 304 352L304 448C304 456.8 311.2 464 320 464C328.8 464 336 456.8 336 448L336 352z" />
          </svg>
          <svg
            viewBox="0 0 640 640"
            fill="currentColor"
            style={{
              width: '1.2em',
              height: '1.2em',
              position: 'absolute',
              opacity: locked ? 0 : 1,
              transition: 'opacity 0.35s ease-in-out',
            }}
          >
            <path d="M480 64C427 64 384 107 384 160L384 224L448 224C483.3 224 512 252.7 512 288L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 288C128 252.7 156.7 224 192 224L352 224L352 160C352 89.3 409.3 32 480 32C550.7 32 608 89.3 608 160L608 208C608 216.8 600.8 224 592 224C583.2 224 576 216.8 576 208L576 160C576 107 533 64 480 64zM448 256L192 256C174.3 256 160 270.3 160 288L160 512C160 529.7 174.3 544 192 544L448 544C465.7 544 480 529.7 480 512L480 288C480 270.3 465.7 256 448 256zM368 416L272 416C263.2 416 256 408.8 256 400C256 391.2 263.2 384 272 384L368 384C376.8 384 384 391.2 384 400C384 408.8 376.8 416 368 416z" />
          </svg>
        </span>
      </CustomTooltip>
    </>
  )
}
